export enum VideoRatioEnum {
    Landscape,
    Vertical
}
